var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherPagesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "41px",
    viewBox: "0 0 33 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "774FF4BD-3674-4EDA-8819-F2F7A4B52BD8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other-pages",
    transform: "translate(-113.000000, -297.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(115.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.9977655,
    y1: 1.02702703,
    x2: 0.00218321015,
    y2: 1.02702703,
    id: "Vector-59-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.7844268,
    y1: 38,
    x2: 14.4999747,
    y2: 29.9316757,
    id: "Vector-59-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.21552202,
    y1: 38,
    x2: 14.4999741,
    y2: 29.9296216,
    id: "Vector-59-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4999733,29.9296224 L6.74779801,29.9296224 C2.92653703,29.8299251 -0.091675902,26.6803341 0.00218321019,22.890379 L0.00218321019,12.3243244 C-0.0928381814,8.53357619 2.92570833,5.38271679 6.74779801,5.28302703 L22.2500789,5.28302703 C26.0729836,5.38160455 29.0927739,8.53279508 28.9977641,12.3243244 L28.9977641,22.8883243 C29.0939484,26.6798657 26.0750687,29.8319916 22.2521495,29.9316757 L14.4999733,29.9296224 Z",
    id: "Vector-59-path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherPagesIcon);
export default __webpack_public_path__ + "static/media/Other Pages Icon.400f536d754fc6e6ec3ada6a5356ba01.svg";
export { ForwardRef as ReactComponent };